import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import CalendaRangeInput from '../../../../General/CalendarRangeInput';
import FormValidator from '../../../../../utils/FormValidator';
import { enumUtil } from '../../../../../utils/Enum';
import Loader from '../../../../shared/Loader/Loader';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import { useSelector } from 'react-redux';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import AmountFormatter from '../../../../../utils/AmountFormatter';
import isNull from '../../../../../utils/NullChecking';
import MultipleCheckboxSelector from '../../../../shared/MultipleCheckboxSelector';
import { ClaimStatus } from '../../../../../utils/Constants';

const SubscriberUpdatePopup = (props) => {

  const API_URL_GENERAL = enumUtil.controller.General;
  const API_UR_ClaimOptions = enumUtil.controller.ClaimOptions;
  let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
  PateintIDR = PateintIDR?.data?.id;
  const { isOpenSubscriber, onClose, previousSubscriberID, updatesubscriberID, previousInsuranceID, updateInsuranceID, previousInsuranceName, updateInsuranceName, IsIDsUpdated, ClaimFor, InsuranceID, PatientInsuranceID, handleFindBy } = props;

  let valModal = {};
  let ValidationModal = {
    NotesVal: '',
  };

  const SEARCHCRITERIA = {
    "PatientID": PateintIDR + "",
    "InsuranceID": ClaimFor === ("INSURANCE" || "BOTH") ? previousInsuranceID + "" : null,
    "SubscriberID": ClaimFor === ("SBRID" || "BOTH") ? previousSubscriberID + "" : null,
    "PatientInsuranceID": PatientInsuranceID + "",
    "DOSFrom": "",
    "DOSTo": "",
    "EntryDateFrom": "",
    "EntryDateTo": "",
    "BillingStatus": "",
    "ClaimFor": ClaimFor,
  };
  const [subscriberData, setsubscriberData] = useState([]);
  const [isUpdate, setisUpdate] = useState(false);
  const [searchParam, setSearchParam] = useState(SEARCHCRITERIA);
  const [validation, setValidation] = useState({ ValidationModal });
  const [Notes, setNotes] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [defaultSelectedData, setDefaultSelectedData] = useState([])
  const [filter, setClearFilter] = useState(false);
  const [TotalClaims, setTotalClaims] = useState(0)
  const [TotalServiceLines, setTotalServiceLines] = useState(0)

  const VisitOptionValidation = async () => {
    let ValidationModal = {
      NotesVal: FormValidator(
        Notes,
        enumUtil.enumValidationType.Required,
        'Notes ',
      )
    };
    await setValidation(ValidationModal);
    valModal = ValidationModal;
  };
  const handleClose = () => {
    onClose()
    handleFindBy()
  }
  const GetSelectedItems = (items) => {
    let arr = [];
    items.map((key, index) => {
      arr.push(key.value)
    })
    setSearchParam({ ...searchParam, BillingStatus: arr.toString() })
  }
  const clearFilter = () => {
    setSearchParam(SEARCHCRITERIA);
    setClearFilter(true);
  }
  const LoadDataSubscriberID = (searchParam) => {
    setIsLoading(true);
    ServerRequestProtected(API_URL_GENERAL + "/GetPatientClaims", 'post', {
      "TableName": enumUtil.enumAPITableName.PatientInsurance,
      SEARCHCRITERIA: searchParam
    })
      .then((response) => {
        setIsLoading(false);
        if (response && response.length > 0) {
          setsubscriberData(response);
          handleTotalAmount(response);
        } else {
          setsubscriberData([]);
          setTotalClaims(0);
          setTotalServiceLines(0);
        }
      }).catch((error) => {
        setIsLoading(false);
        setsubscriberData([]);
        setTotalClaims(0);
        setTotalServiceLines(0);
      });
  };

  useEffect(() => {
    if (isOpenSubscriber) {
      LoadDataSubscriberID(searchParam);
    }
  }, [isOpenSubscriber]);
  const handleDelete = (index) => {
    const updatedList = [...subscriberData.slice(0, index), ...subscriberData.slice(index + 1)];
    setsubscriberData(updatedList)
  }
  const handleSaveUpdateSubscriberID = async () => {
    await VisitOptionValidation()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    }
    else {
      setIsLoading(true);
      clearFilter();
      let data = {
        Note: Notes
      }
      const updateddata = subscriberData.map((item) => ({
        ClaimID: item.ClaimID + "",
        SubscriberID: updatesubscriberID + "",
        InsuranceID: InsuranceID + "",
        PatientInsuranceID: PatientInsuranceID + "",
      }));
      let saveModal = {
        TableName: enumUtil.enumAPITableName.UpdateClaim,
        Value: "SUBSCRIBERID",
        Data: data,
        ListofData: updateddata,
      };
      console.log("saveModal:", saveModal);
      ServerRequestProtected(API_UR_ClaimOptions + "/UpdateClaim", 'post', saveModal)
        .then((response) => {
          setIsLoading(false);
          NotificationHandler('Record Saved Successfully! ', enumUtil.enumtoaster.success);
          setNotes('');
          LoadDataSubscriberID(searchParam)
          setisUpdate(true);
        }).catch((error) => {
          setIsLoading(false);
          setNotes('');
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        });
    }
  };
  const SearchByParam = () => {
    if (!isNull(searchParam)) {
      LoadDataSubscriberID(searchParam)
    } else {
      LoadDataSubscriberID()
    }
  }
  const handleTotalAmount = (data) => {
    let counter = 0
    let claimid
    let totalWriteOff = 0
    data.map((item) => {
      if (item.ClaimID !== claimid) {
        counter = counter + 1
      }
      claimid = item.ClaimID
    })
    setTotalServiceLines(data.length)
    setTotalClaims(counter)
  }

  const handleHeaderName = () => {
    console.log("IsIDsUpdated", IsIDsUpdated);
    if (IsIDsUpdated?.InsIDUpdated && IsIDsUpdated?.SbrIDUpdated) {
      return <span>Update Subscriber/Insurance ID</span>
    }
    else if (IsIDsUpdated?.InsIDUpdated && !IsIDsUpdated?.SbrIDUpdated) {
      return <span>Update Insurance ID</span>
    }
    else if (!IsIDsUpdated?.InsIDUpdated && IsIDsUpdated?.SbrIDUpdated) {
      return <span>Update Subscriber ID</span>
    }
    else {
      return <span>Update ID</span>
    }
  }
  return (
    <div>
      <Modal show={isOpenSubscriber} centered dialogClassName=" hk-modal-v1 za-subscriber-id">
        <Modal.Body>
          {isLoading ? <Loader /> : null}
          <div className='d-flex justify-content-between align-items-center mb-12 px-10'>
            <p></p>
            <p className='heading fs-14'>{handleHeaderName()}</p>
            <i className='icon-Icon-metro-cross' onClick={handleClose} ></i>
          </div>
          <div className='row px-10 mx-0 align-items-end mb-12'>
            <div className='col-md-4 ps-0'>
              <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Entry Date']} />
            </div>
            <div className='col-md-5 row m-0 align-items-end ps-0'>
              <div className='col-md-6 ps-0'>
                <div className="input mb-0">
                  <label htmlFor="" className='heading fs-12'>Status</label>
                  < MultipleCheckboxSelector
                    ItemLists={ClaimStatus}
                    placeHolder="Select Status"
                    GetSelectedItems={GetSelectedItems}
                    clearFilter={filter}
                    setClearFilter={setClearFilter}
                    defaultSelectedData={defaultSelectedData}
                  />
                </div>
              </div>
              <div className='col-md-6 px-0'>
                <div className='btns-group-flex claims_btns'>
                  <button className='btn btn-orange btn-xs no-width rounded'
                    onClick={SearchByParam}>Search</button>
                  <div className='line-border'></div>
                  <button className='btn btn-outline btn-xs no-width rounded' onClick={clearFilter}>Clear</button>
                </div>
              </div>
            </div>
            {/* <div className='col-md-2 align-content-end'>
              <button className='btn btn-orange rounded'onClick={SearchByParam}>Search</button>
              <div className='line-border'></div>
              <button className='btn btn-outline btn-xs no-width rounded'onClick={clearFilter}>Clear</button>
            </div> */}

            <div className='col-md-3 text-end px-0'>
              {IsIDsUpdated?.SbrIDUpdated ?
                <>
                  <p className='text font-m drk-green-clr fst-italic fs-10 '>Prev Sbr ID : <span title={previousSubscriberID}>{previousSubscriberID}</span></p>
                  <p className='text font-m drk-green-clr fst-italic fs-10'>New Sbr ID : <span title={updatesubscriberID}>{updatesubscriberID}</span></p>
                </> : <></>}
              {IsIDsUpdated?.InsIDUpdated ?
                <>
                  <p className='text font-m drk-green-clr fst-italic fs-10 '>Prev Ins ID : <span title={previousInsuranceName}>{previousInsuranceName}</span></p>
                  <p className='text font-m drk-green-clr fst-italic fs-10'>New Ins ID : <span title={updateInsuranceName}>{updateInsuranceName}</span></p>
                </> : <></>}
            </div>
          </div>
          <div class="ar-writeoff-screen">
            <div className='ar-row '>
              <p className='heading'>Subscriber </p>
              <div className='d-flex align-items-center'>
                <p className='text ar-light-color fs-11 fw-500 pe-2'>Total Claims: <span className='fw-600'>{subscriberData.length}</span></p>
                {/* <p className='text ar-light-color fs-11 fw-500 ps-1'>Total ServceLines:  <span className='fw-600'>{TotalServiceLines}</span></p> */}
              </div>
            </div>
          </div>

          <div className='card-body hk-expand-table ad-expand-table service_line mb-2 mx-10 za_table'>
            <table className=''>
              <thead>
                <tr>
                  <th className='heading fs-12'>Patient</th>
                  <th className='heading fs-12'>Account#</th>
                  {IsIDsUpdated?.SbrIDUpdated && <>
                    <th className='heading fs-12'>Current Subscriber ID</th>
                    <th className='heading fs-12 text-center'>Subscriber ID</th>
                  </>}
                  {IsIDsUpdated?.InsIDUpdated &&
                    <>
                      <th className='heading fs-12'>Current Insurance ID</th>
                      <th className='heading fs-12 text-center'>Insurance ID</th>
                    </>
                  }
                  <th className='heading fs-12'>Claim ID</th>
                  <th className='heading fs-12'>DOS</th>
                  <th className='heading fs-12'>Billed</th>
                  <th className='heading fs-12'>Paid</th>
                  <th className='heading fs-12'>Ins Bal</th>
                  <th className='heading fs-12'>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {subscriberData && subscriberData.map((item, index) => {
                  return (
                    <tr>
                      <td className='text fs-12'>{item.Patient}</td>
                      <td className='text'>{item.AccountNumber}</td>
                      {IsIDsUpdated?.SbrIDUpdated && <> <td className='text'>{previousSubscriberID}</td>
                        <td className='text'>
                          {isUpdate ? item?.PrimarySubscriberID
                            // <div className="hk-table-flex">

                            //   <input
                            //     type="text"
                            //     className="form-control w-100"
                            //     name="UpdateAuthorization"
                            //     id="UpdateAuthorization"
                            //     variant="outlined"
                            //     value={item.PrimarySubscriberID}
                            //     readOnly
                            //   />
                            // </div>
                            : updatesubscriberID
                            // <div className="hk-table-flex">

                            //   <input
                            //     type="text"
                            //     className="form-control w-100"
                            //     name="UpdateAuthorization"
                            //     id="UpdateAuthorization"
                            //     variant="outlined"
                            //     value={updatesubscriberID}
                            //     readOnly
                            //   />
                            // </div>
                          }
                        </td>
                      </>}
                      {IsIDsUpdated?.InsIDUpdated && <>
                        <td className='text'>{previousInsuranceName}</td>
                        <td className='text'>
                          {isUpdate ? (item?.ShortName
                            // <div className="hk-table-flex">

                            //   <input
                            //     type="text"
                            //     className="form-control w-100"
                            //     name="UpdateAuthorization"
                            //     id="UpdateAuthorization"
                            //     variant="outlined"
                            //     value={item.PrimaryInsuranceID}
                            //     readOnly
                            //   />
                            // </div>
                          ) : (updateInsuranceName
                            // <div className="hk-table-flex">

                            //   <input
                            //     type="text"
                            //     className="form-control w-100"
                            //     name="UpdateAuthorization"
                            //     id="UpdateAuthorization"
                            //     variant="outlined"
                            //     value={updateInsuranceName}
                            //     readOnly
                            //   />
                            // </div>
                          )}
                        </td>
                      </>}
                      <td className='text'>{item.ClaimID}</td>
                      <td className='heading fs-12'>{item.DOS}</td>
                      <td className='text'><AmountFormatter amount={item.PrimaryBilledAmount} /></td>
                      <td className='text'><AmountFormatter amount={item.PrimaryPaid} /></td>
                      <td className='text'><AmountFormatter amount={item.PrimaryBalance} /></td>
                      <td className='text'>{item.BillingStatus}</td>
                      <td className='text'>
                        <i className='bi bi-trash-fill' onClick={() => handleDelete(index)}> </i>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className={validation.NotesVal ? 'input error pb-2 mx-2' : 'input pb-2 mx-2'}>
            <label className='mb-1' >Notes</label>
            <textarea
              className="form-control doc-textarea"
              placeholder="Add Notes" value={Notes} onChange={(e) => setNotes(e.target.value)}
              rows={2}
            >
            </textarea>
            {validation.NotesVal}
          </div>
          <div className='br-top-1 br-clr'>
            <div className="modal_footer  ar-border-color px-10">
              <div className="text-end">
                <div className="btns-group">
                  {isUpdate === true ?
                    <div className='d-flex align-items-center justify-content-end'>
                      <CSVLink className='ar-btn-primary border-0 btn' filename={"SubscriberData.csv"} data={subscriberData}>Export</CSVLink>
                    </div>
                    :
                    <div className="btns-group">
                      <button className="btn btn-gray" onClick={onClose}>Cancel</button>
                      <button className="btn btn-orange" onClick={handleSaveUpdateSubscriberID}>Update</button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div >
  )
}

export default SubscriberUpdatePopup